/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Label from "../../components/label";
import { Table } from "reactstrap";
import MakeAPICall from "../../apiCalls/common";
import {
  getConsultCostList,
  instantHushConsultCostAPI,
  instantSwitchConsultCostAPI,
  instantSwitchMCConsultCostAPI,
  instantSwitchMedicareConsultCostAPI,
  medicareConsultCostAPIRoute
} from "../../apiRoutes";

class ConsultCostPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      constants: props.constants,
      instantSwitchPMFee: props.constants.instantSwitchPMFee,
      instantSwitchMedicarePMFee: props.constants.instantSwitchMedicarePMFee,
      instantSwitchAccess: props.commonReducers.accessGranted && props.commonReducers.accessGranted.isInstantSwitchAccessGranted ? true : false,
      instantSwitchMCAccess: props.commonReducers.accessGranted && props.commonReducers.accessGranted.isInstantSwitchMCAccessGranted ? true : false,
      instantConsultAccess: props.commonReducers.accessGranted && props.commonReducers.accessGranted.isInstantConsultAccessGranted ? true : false,
      canTakeMedicareConsult: props.auth && props.auth.user && props.auth.user.userData && props.auth.user.userData.canTakeMedicareConsult ? true : false,
      tax: props.constants.tax,
      instantConsultAPICall: null,
      instantConsultMedicareAPICall: null,
      instantHushAPICall: null,
      instantSwitchMedicareAPICall: null,
      instantSwitchMCAPICall: null,
      instantSwitchAPICall: null,
      apiData: null,
      medicareConsultData: [],
      // instantSwitchMedicareData: [],
      instantSwitchConsultData: [],
      instantSwitchMCConsultData: [],
      instantHushConsultData: [],
      instantHushPMFee: props.constants.instantHushPMFee,
      instantSwitchMedicinalCannabisPMFee: props.constants.instantSwitchMedicinalCannabisPMFee || 0
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    console.log("Props -- here --> ", this.props.commonReducers);
    const grantedAccess = this.props.commonReducers.accessGranted;
    if (grantedAccess.isInstantConsultAccessGranted) {
      this.getConsultCost();
    }

    if (grantedAccess.isInstantSwitchAccessGranted) {
      this.getInstantSwitchConsultCost();
    }

    if (grantedAccess.isInstantSwitchMCAccessGranted) {
      this.getInstantSwitchMCConsultCost();
    }

    if (grantedAccess.isInstantHushAccessGranted) {
      this.getInstantHushConsultCost();
    }

    if (this.state.canTakeMedicareConsult) {
      this.getMedicareConsultCost();
    }
  }

  getConsultCost = () => {
    this.setState({
      instantConsultAPICall: {
        reqType: "GET",
        reqURL: getConsultCostList,
        dataObj: {},
        params: {},
        headers: {},
        successCallback: res => {
          this.setState({
            apiData: res.data.data,
          });
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      }
    });
  };

  getMedicareConsultCost = () => {
    this.setState({
      instantConsultMedicareAPICall: {
        reqType: "GET",
        reqURL: medicareConsultCostAPIRoute,
        dataObj: {},
        params: {},
        headers: {},
        successCallback: res => {
          let mappedConsultDetails = [];

          const grantedAccess = this.props.commonReducers.accessGranted;
          if (grantedAccess.isInstantConsultAccessGranted) {
            res.data.data.consultDetailData.map((value) => {
              mappedConsultDetails.push(
                {
                  itemId: value.mbsItemNo,
                  duration: `${value.consultMode} ${(value.consultDuration)}`,
                  bulkBilledFee: (value.consultPrice).toFixed(2),
                  gst: "1.00",
                  consultPrice: value.consultPrice,
                  type: 'INSTANT_CONSULT',
                  incentiveGroup: value.feeNote
                }
              )
            });
          }

          this.getInstantSwitchMedicareConsultCost(mappedConsultDetails);
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      }
    });
  };

  getInstantSwitchConsultCost = () => {
    this.setState({
      instantSwitchAPICall: {
        reqType: "GET",
        reqURL: instantSwitchConsultCostAPI,
        dataObj: {},
        params: {},
        headers: {},
        successCallback: res => {
          console.log({ shouldGetInstantSwitchConsultCost: res.data.data });

          this.setState({
            instantSwitchConsultData: res.data.data.consultDetailData,
          });
        },
        failureCallback: err => {
          console.log({ shouldGetInstantSwitchConsultCost: "failed" });
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      }
    });
  };

  getInstantHushConsultCost = () => {
    this.setState({
      instantHushAPICall: {
        reqType: "GET",
        reqURL: instantHushConsultCostAPI,
        dataObj: {},
        params: {},
        headers: {},
        successCallback: res => {
          console.log("--- 111 --- ", res);
          this.setState({
            instantHushConsultData: res.data.data.consultDetailData,
          });
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      }
    });
  };

  getInstantSwitchMCConsultCost = () => {
    console.log({ instantSwitchMCConsultData: "getting" })
    this.setState({
      instantSwitchMCAPICall: {
        reqType: "GET",
        reqURL: instantSwitchMCConsultCostAPI,
        dataObj: {},
        params: {},
        headers: {},
        successCallback: res => {
          console.log("--- 111 --- ", res);
          console.log({ instantSwitchMCConsultData: res.data.data.consultDetailData })
          this.setState({
            instantSwitchMCConsultData: res.data.data.consultDetailData,
          });
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      }
    });
  };

  getInstantSwitchMedicareConsultCost = (instantConsultMedicareData) => {
    this.setState({
      instantSwitchMedicareAPICall: {
        reqType: "GET",
        reqURL: instantSwitchMedicareConsultCostAPI,
        dataObj: {},
        params: {},
        headers: {},
        successCallback: res => {
          let mappedConsultDetails = [];
          const grantedAccess = this.props.commonReducers.accessGranted;
          if (grantedAccess.isInstantSwitchAccessGranted) {
            res.data.data.consultDetailData.map((value) => {
              mappedConsultDetails.push(
                {
                  itemId: value.mbsItemNo,
                  duration: `${value.consultMode} ${(value.consultDuration)}`,
                  bulkBilledFee: (value.consultPrice).toFixed(2),
                  gst: "1.00",
                  consultPrice: value.consultPrice,
                  type: 'INSTANT_SWITCH'
                }
              )
            });
          }
          const mergedMedicareConsultPrice = [...instantConsultMedicareData, ...mappedConsultDetails];
          this.setState({
            medicareConsultData: mergedMedicareConsultPrice
          });
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      }
    });
  };

  render() {
    return (
      <div className="row rounded p-3 consult-cost-page">
        <div className="col-sm-3 p-3">
          <Label title="Consult Costs" className="big" />
        </div>
        <div className="col-sm-12 border-bottom"></div>
        {
          this.state.canTakeMedicareConsult && this.state.medicareConsultData.length > 0 && (
            <BulkBilledConsultCostTable
              medicareConsultData={this.state.medicareConsultData}
              MedicarePMFee={this.state.MedicarePMFee}
              instantSwitchPMFee={this.state.instantSwitchMedicarePMFee}
              constants={this.state.constants}
              instantSwitchAccess={this.state.instantSwitchAccess}
              instantConsultAccess={this.state.instantConsultAccess}
            />
          )
        }
        <div className="col-sm-12 mt-4">
          <div className="consult-table-title">Private Fee Earnings</div>
          <Table hover className="custom-table">
            <thead>
              <tr>
                <th>Duration</th>
                <th style={{
                  minWidth: '240px'
                }}>Description</th>
                <th>Consult Cost</th>
                <th>Practice Management Fee</th>
                <th>GST on Practice Management Fee</th>
                <th>Earnings</th>
              </tr>
            </thead>
            <tbody>
              {this.state.apiData &&
                this.state.apiData.consultDetails.map((values, index) => {
                  return (
                    <tr key={index}>
                      <td className="primary-color">
                        <span className="bold-font">
                          Instant Consult
                        </span>{" "}
                      </td>
                      <td className="primary-color">
                        <span className="bold-font">{values.consultMode} </span>
                        {/* {values.consultMode === "<" ? <i className="fas fa-less-than"></i> : <i className="fas fa-greater-than"></i>} */}
                        <span className="bold-font">
                          {values.consultDuration} Mins
                        </span>{" "}
                      </td>
                      <td> ${values.consultPrice.toFixed(2)}</td>
                      <td> ${this.state.apiData.PMFee.toFixed(2)}</td>
                      <td>
                        {" "}
                        $
                        {(
                          (this.state.apiData.PMFee * this.state.apiData.tax) /
                          100
                        ).toFixed(2)}
                      </td>
                      <td>
                        {" "}
                        <span className="bold-font">
                          $
                          {(
                            values.consultPrice -
                            this.state.apiData.PMFee -
                            (this.state.apiData.PMFee *
                              this.state.apiData.tax) /
                            100
                          ).toFixed(2)}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              {this.state.instantSwitchConsultData && this.state.instantSwitchConsultData.map((values, index) => {
                return (
                  <tr key={index}>
                    <td className="primary-color">
                      <span className="bold-font">{values.consultMode} </span>
                      {/* {values.consultMode === "<" ? <i className="fas fa-less-than"></i> : <i className="fas fa-greater-than"></i>} */}
                      <span className="bold-font">
                        Instant Switch
                      </span>{" "}
                    </td>
                    <td className="primary-color">
                      <span className="bold-font">
                        {/* The management of nicotine dependence, or nicotine and smoking cessation counselling, care, treatment plan and advice */}
                        {values.description}
                      </span>{" "}
                    </td>
                    <td> ${values.consultPrice.toFixed(2)}</td>
                    <td> ${this.state.instantSwitchPMFee.toFixed(2)}</td>
                    <td>
                      {" "}
                      $
                      {(
                        (this.state.instantSwitchPMFee * this.state.tax) /
                        100
                      ).toFixed(2)}
                    </td>
                    <td>
                      {" "}
                      <span className="bold-font">
                        $
                        {(
                          values.consultPrice -
                          this.state.instantSwitchPMFee -
                          (this.state.instantSwitchPMFee *
                            this.state.tax) /
                          100
                        ).toFixed(2)}
                      </span>
                    </td>
                  </tr>
                );
              })}

              {!!this.state.instantSwitchMCConsultData?.length && this.state.instantSwitchMCConsultData.map((values, index) => {
                return (
                  <tr key={index}>
                    <td className="primary-color">
                      <span className="bold-font">{values.consultMode} </span>
                      {/* {values.consultMode === "<" ? <i className="fas fa-less-than"></i> : <i className="fas fa-greater-than"></i>} */}
                      <span className="bold-font">
                        Instant Leaf
                      </span>{" "}
                    </td>
                    <td className="primary-color">
                      <span className="bold-font">
                        {values.description}
                      </span>{" "}
                    </td>
                    <td> ${values.consultPrice.toFixed(2)}</td>
                    <td> ${this.state.instantSwitchMedicinalCannabisPMFee.toFixed(2)}</td>
                    <td>
                      {" "}
                      $
                      {(
                        (this.state.instantSwitchMedicinalCannabisPMFee * this.state.tax) /
                        100
                      ).toFixed(2)}
                    </td>
                    <td>
                      {" "}
                      <span className="bold-font">
                        $
                        {(
                          values.consultPrice -
                          this.state.instantSwitchMedicinalCannabisPMFee -
                          (this.state.instantSwitchMedicinalCannabisPMFee *
                            this.state.tax) /
                          100
                        ).toFixed(2)}
                      </span>
                    </td>
                  </tr>
                );
              })}

              {!!this.state.instantHushConsultData?.length && this.state.instantHushConsultData.map((values, index) => {
                return (
                  <tr key={index}>
                    <td className="primary-color">
                      <span className="bold-font">{values.consultMode} </span>
                      {/* {values.consultMode === "<" ? <i className="fas fa-less-than"></i> : <i className="fas fa-greater-than"></i>} */}
                      <span className="bold-font">
                        Instant Hush
                      </span>{" "}
                    </td>
                    <td className="primary-color">
                      <span className="bold-font">
                        {values.description}
                      </span>{" "}
                    </td>
                    <td> ${values.consultPrice.toFixed(2)}</td>
                    <td> ${this.state.instantHushPMFee.toFixed(2)}</td>
                    <td>
                      {" "}
                      $
                      {(
                        (this.state.instantHushPMFee * this.state.tax) /
                        100
                      ).toFixed(2)}
                    </td>
                    <td>
                      {" "}
                      <span className="bold-font">
                        $
                        {(
                          values.consultPrice -
                          this.state.instantHushPMFee -
                          (this.state.instantHushPMFee *
                            this.state.tax) /
                          100
                        ).toFixed(2)}
                      </span>
                    </td>
                  </tr>
                );
              })}

            </tbody>
          </Table>
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.instantConsultAPICall} />
        <MakeAPICall apiParam={this.state.instantConsultMedicareAPICall} />
        <MakeAPICall apiParam={this.state.instantHushAPICall} />
        <MakeAPICall apiParam={this.state.instantSwitchMedicareAPICall} />
        <MakeAPICall apiParam={this.state.instantSwitchAPICall} />
        <MakeAPICall apiParam={this.state.instantSwitchMCAPICall} />
      </div>
    );
  }
}

class BulkBilledConsultCostTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bulkBilledConsultCost: props.medicareConsultData,
      instantSwitchPMFee: props.instantSwitchPMFee,
      MedicarePMFee: props.constants.MedicarePMFee || 10,
      tax: props.constants.tax || 10
    }
  }
  render() {
    const BulkBilledCostData = [
      {
        itemId: "91800",
        duration: "< 20",
        bulkBilledFee: "39.10",
        pmFee: "10.00",
        gst: "1.00",
        earnings: "28.10"
      },
      {
        itemId: "91801",
        duration: "< 40",
        bulkBilledFee: "75.75",
        pmFee: "10.00",
        gst: "1.00",
        earnings: "64.75"
      },
      {
        itemId: "91802",
        duration: "> 40",
        bulkBilledFee: "111.50",
        pmFee: "10.00",
        gst: "1.00",
        earnings: "100.50"
      }
    ];
    return (
      <div className="col-sm-12 mt-4">
        <div className="consult-table-title">Bulk-Billed Earnings</div>
        {
          this.props.instantConsultAccess === true ? (
            <Fragment>
              <Label
                className="bold-font mb-0"
                title="Criteria: patients under 12 months of age"
              />
              <Table hover className="custom-table">
                <thead>
                  <tr>
                    <th>MBS Item No. </th>
                    <th>Bulk-Billed Fee</th>
                    <th>Practice Management Fee</th>
                    <th>GST on Practice Management Fee</th>
                    <th>Earnings</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.bulkBilledConsultCost.map((values, index) => {
                    return (values.type === "INSTANT_CONSULT" ?
                      <tr key={index}>
                        <td>
                          <div className="first-cell">
                            <div className="font-14">{values.itemId}</div>
                            <div className="primary-color bold-font">
                              {values.duration} Mins
                            </div>
                          </div>
                        </td>
                        <td>${values.bulkBilledFee}<sup>{values.incentiveGroup || ''}</sup></td>
                        {/* <td>${values.pmFee}</td> */}
                        {
                          values.type === "INSTANT_CONSULT" && (
                            <Fragment>
                              <td>${(this.state.MedicarePMFee).toFixed(2)}</td>
                              <td>${((this.state.MedicarePMFee * this.state.tax) / 100).toFixed(2)}</td>
                              <td>
                                <span className="bold-font">${(values.consultPrice - this.state.MedicarePMFee - ((this.state.MedicarePMFee * this.state.tax) / 100)).toFixed(2)}</span>
                                {/* Earning = consult_cost - Medicare Fee - GST  */}
                              </td>
                            </Fragment>
                          )
                        }
                      </tr>
                      : (''));
                  })}
                </tbody>
              </Table>


            </Fragment>
          ) : ("")
        }

        {/*{*/}
        {/*  this.props.instantSwitchAccess === true ? (*/}
        {/*    <Fragment>*/}
        {/*      <Label*/}
        {/*        className="bold-font mb-0"*/}
        {/*        title="Criteria: for nicotine and smoking cessation counselling, care and advice"*/}
        {/*      />*/}
        {/*      <Table hover className="custom-table">*/}
        {/*        <thead>*/}
        {/*          <tr>*/}
        {/*            <th>MBS Item No. </th>*/}
        {/*            <th>Bulk-Billed Fee</th>*/}
        {/*            <th>Practice Management Fee</th>*/}
        {/*            <th>GST on Practice Management Fee</th>*/}
        {/*            <th>Earnings</th>*/}
        {/*          </tr>*/}
        {/*        </thead>*/}
        {/*        <tbody>*/}
        {/*          {this.state.bulkBilledConsultCost.map((values, index) => {*/}
        {/*            return (*/}
        {/*              <Fragment>*/}
        {/*                {*/}
        {/*                  values.type === "INSTANT_SWITCH" && (*/}

        {/*                    <tr key={index}>*/}
        {/*                      <td>*/}
        {/*                        <div className="first-cell">*/}
        {/*                          <div className="font-14">{values.itemId}</div>*/}
        {/*                          <div className="primary-color bold-font">*/}
        {/*                            {values.duration} Mins*/}
        {/*                          </div>*/}
        {/*                        </div>*/}
        {/*                      </td>*/}
        {/*                      <td>${values.bulkBilledFee}</td>*/}
        {/*                      <td>${(this.state.instantSwitchPMFee).toFixed(2)}</td>*/}
        {/*                      <td>${((this.state.instantSwitchPMFee * this.state.tax) / 100).toFixed(2)}</td>*/}
        {/*                      <td>*/}
        {/*                        <span className="bold-font">${(values.consultPrice - this.state.instantSwitchPMFee - ((this.state.instantSwitchPMFee * this.state.tax) / 100)).toFixed(2)}</span>*/}
        {/*                        /!* Earning = consult_cost - Medicare Fee - GST  *!/*/}
        {/*                      </td>*/}
        {/*                    </tr>*/}
        {/*                  )*/}
        {/*                }*/}
        {/*              </Fragment>);*/}

        {/*          })}*/}
        {/*        </tbody>*/}
        {/*      </Table>*/}
        {/*    </Fragment>*/}
        {/*  ) : ("")*/}
        {/*}*/}

        {this.props.constants.icMBSItemIncentives && this.props.constants.icMBSItemIncentives.map((incentive, index) => (
          <Fragment key={index}>
            <Label
              className="bold-font"
              title={`${incentive.feeNote}Additional $${(incentive.amount).toFixed(2)} ${incentive.description || 'Bulk-Billing Incentive for patients aged under 16 and Concession Card Holders'} (Item No ${incentive.mbsItemNo})`}
            />
            {index < this.props.constants.icMBSItemIncentives.length - 1 && <br />}
          </Fragment>
        ))}
      </div>
    );
  }
}

// export default ConsultCostPage;
const mapStateToProps = props => ({
  constants:
    props.auth && props.auth.user && props.auth.user.appConstant
      ? props.auth.user.appConstant
      : {},
  commonReducers: props.commonReducers,
  auth: props.auth
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConsultCostPage));
